import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process } from '@progress/kendo-data-query';
import { LoanDetailsListOfLoansService } from '../../loan-details-modal/loan-details-list-of-loans.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SiteSearchService, SiteSearchDataModel } from '../../services/site-search.service';
import { Router } from '@angular/router';
import { State } from '@progress/kendo-data-query';

@Component({
    selector: 'site-search-dialog',
    templateUrl: './site-search-dialog.component.html',
    styleUrls: ['./site-search-dialog.component.scss'],
})
export class SiteSearchDialogComponent implements OnInit, OnDestroy {
    results: SiteSearchDataModel[];
    gridView: GridDataResult;
    sortable = {
        mode: 'single',
        allowUnsort: true,
    };
    type: 'numeric' | 'input' = 'input';
    allResults: boolean = false;
    groupable = true;
    scrollable = 'scrollable';
    pageable = {
        refresh: true,
        info: true,
        type: this.type,
        previousNext: true,
        pageSizes: [5, 10, 20],
    };
    loading: boolean;
    state: State = {
        skip: 0,
        take: 5,
        //filter: { filters: [], logic: "or" },
        group: [
            {
                field: 'rowType',
                dir: 'desc',
            },
        ],
        sort: [
            {
                field: 'name',
                dir: 'asc',
            },
        ],
    };
    keys: string[] = ['identifier', 'name', 'description', 'rowType', 'totalRows'];
    searchTypes: string[] = ['L', 'E', 'H'];
    total: number = 0;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private listOfLoansService: LoanDetailsListOfLoansService,
        public dialogRef: MatDialogRef<SiteSearchDialogComponent>,
        private router: Router,
        private siteSearchService: SiteSearchService
    ) {}

    ngOnInit() {
        this.loading = true;
        this.results = this.data.results;
        this.getTotalRecords();
        this.loadData();
    }

    updateGrid() {
        this.loading = true;
        this.siteSearchService
            .getSiteSearchResults(
                this.data.search,
                this.searchTypes.toString(),
                this.state.skip,
                this.state.take,
                this.getSortField(),
                this.allResults
            )
            .subscribe(
                (data) => {
                    this.loading = false;
                    this.results = data;
                    this.loadData();
                },
                (error) => {
                    this.loading = false;
                    throw new Error(error);
                }
            );
    }

    loadData() {
        this.gridView = {
            //if not grouping then columns need to be sorted locally
            data: this.state.group.length
                ? process(this.results, {
                      group: this.state.group,
                  }).data
                : orderBy(this.results, this.state.sort),
            total: this.total,
        };
        this.loading = false;
    }

    getSortField(): string {
        if (this.state.sort.length && this.gridView.data.length) {
            let sortCol = this.keys.indexOf(this.state.sort[0].field) + 1; //sql index starts at 1;
            if (sortCol > 0) {
                let sortDir = this.state.sort[0].dir ? this.state.sort[0].dir.charAt(0) : 'a';
                return sortCol + sortDir;
            }
        }
        return '1a';
    }

    getTotalRecords() {
        //loop through unique types that are returned(L,E,H) and add the total for the total count
        this.results
            .filter(
                (value, index, self) => self.map((x) => x.rowType).indexOf(value.rowType) === index
            )
            .forEach((uniqueType) => {
                this.total += uniqueType?.totalRows ?? 0;
            });
    }

    dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.updateGrid();
    }

    cellClickHandler(record) {
        if (record.rowType === 'L') {
            this.openLoanModal(record.identifier);
        } else if (record.rowType === 'E') {
            this.openPage('/settings/employees/', record.identifier);
        } else if (record.rowType === 'H') {
            this.openPage('directory/record/', record.identifier);
        }
        this.dialogRef.close();
    }

    openLoanModal(identifier: string) {
        let loanNumbers: string[] = this.results
            .filter((x) => x.rowType === 'L')
            .map((x) => x.identifier);
        let index = loanNumbers.findIndex((loanNumber) => loanNumber === identifier);
        this.listOfLoansService.changeListOfLoans({
            loanNumbers: loanNumbers,
            index: index,
        });
        this.router.navigate([{ outlets: { modal: 'loanDetails' + '/' + identifier } }]);
    }

    openPage(route: string, id: string) {
        this.router.navigate([`${route}${id}`]);
    }

    switchChange() {
        this.allResults = !this.allResults;
        this.clearGrid();
        this.updateGrid();
    }

    clearGrid() {
        this.gridView = {
            data: [],
            total: 0,
        };
        this.loading = true;
    }

    ngOnDestroy() {}
}
